import controller from './monthly-reporting-grid-controller';
import template from './monthly-reporting-grid.html'

const MonthlyReportingGridComponent = {
    bindings: {
        columns: '<',
        isRollupEnabled: '<',
        popoverTemplate: '<',
        reportList: '<',
        restrictRollupToOneClient: '<',
        rollupUrl: '<',
        onUpdateRollupUrl: '&',
        allowMultipleMonthSelection: '<'
    },
    controller,
    template,
};

export default MonthlyReportingGridComponent;



// WEBPACK FOOTER //
// ./app/common/monthly-reporting/monthly-reporting-grid/monthly-reporting-grid-component.js